module.exports = __webpack_public_path__ + "img/041-thermometer-1.4a27d364.svg";